var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommonAttendanceManageModal',{attrs:{"employee":_vm.employee,"attendance":_vm.attendance,"changed-id":_vm.attendanceStatusId},on:{"onSubmitClick":_vm.handleManageSubmission}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }